import { useQuery } from 'react-query';
import FTPService from '~/api/services/ftp';
import { onError } from '~/utils/helpers';

const getFtpLogsList = (data?) => useQuery(
  'ftp-logs-query',
  () => FTPService.getFtpsLogs(data),
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFtpLogsOptions = () => useQuery(
  'ftp-logs-options-query',
  () => FTPService.getFtpsLogsOptions(),
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const FTPLogsQuery = {
  getFtpLogsList,
  getFtpLogsOptions
}
